import styled from 'styled-components';

export const PageContainer = styled.div`
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background: linear-gradient(180deg, #2D1B69 0%, #4A2B8A 100%) !important;
  
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 9999 !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
`;

export const BackgroundGradient = styled.div`
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: linear-gradient(180deg, #2D1B69 0%, #4A2B8A 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  z-index: 9999 !important;
  min-width: 100% !important;
  min-height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  
  width: 100% !important;
  height: 100% !important;
  left: 0 !important;
  top: 0 !important;
  right: auto !important;
  bottom: auto !important;
  
  /* Override any potential container constraints */
  transform: none !important;
  overflow: visible !important;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
  color: white;
  font-family: var(--font-family-ibm_plex_sans);
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
`;

export const LogoIcon = styled.span`
  height: 40px;
  width: 60px;
`;

export const LogoImage = styled.img`
   height: 40px;
   width: 60px;
`;

export const LogoText = styled.div`
  font-size: 40px;
  font-weight: 800;
  color: white;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const ContentContainer = styled.div`
  box-sizing: border-box;
  max-height: calc(100vh - 120px); /* browsers without dvh (older iPads, Chromebooks) */
  max-height: calc(100dvh - 120px);
  overflow-y: auto;
  margin-top: 48px;
  background: white;
  border-radius: 16px;
  padding: 32px 24px;
  @media (max-width: 480px) { padding: 24px 16px; }
  max-width: 500px;
  width: calc(100vw - 32px);
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-family: var(--font-family-ibm_plex_sans);
  text-align: center;
  z-index: 10;
`;

export const WhiteBox = styled.div`
  background: white;
  border-radius: 16px;
  padding: 40px;
  max-width: 300px;
  width: 100%;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-family: var(--font-family-ibm_plex_sans);
  text-align: center;
`;

export const CloseIcon = styled.button`
  background: none;
  border: none;
  padding: 0;
  img { width: 100%; height: 100%; }
  position: absolute;
  top: 24px;
  right: 24px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 20;
`;

export const Heading = styled.h2`
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 24px 0;
  line-height: 1.3;
`;

export const CouponContainer = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid #B2AEB7;
  border-radius: 50px;
  overflow: hidden;
  margin-bottom: 16px;  
`;

export const CouponCode = styled.div`
  min-width: 0;
  overflow-wrap: anywhere;
  flex: 1;
  padding: 16px 20px;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  background: white;
  border-right: 2px solid #e0e0e0;
`;

export const CopyButton = styled.button`
  background: #7200E0;
  color: white;
  border: none;
  padding: 16px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
  
  &:hover {
    background: #5A00B8;
  }
`;

export const CopyIcon = styled.span`
  font-size: 16px;
  display: flex;
  align-items: center;
  
  img {
    transform: rotate(-90deg);
  }
`;

export const InstructionText = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 20px 0;
  line-height: 1.4;
  font-style: italic;
  border-bottom: 1px solid  #C9C6CC;
  padding: 24px;
  background: white;
`;

export const UpgradeButton = styled.button`
  background: #7200E0;
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #5A00B8;
  }
`;

export const ConeLeft = styled.img`
  position: absolute;
  bottom: 80px;
  left: 120px;
  width: 80px;
  height: 80px;
  z-index: 1;
`;

export const ConeRight = styled.img`
  position: absolute;
  bottom: 80px;
  right: 60px;
  width: 80px;
  height: 80px;
  transform: rotate(-90deg);
  z-index: 1;
`;
